/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { UserSystemRoleIntMapper } from '../users';

import {
  MilestoneEventDetailsDto,
  MilestoneEventFiresType,
  MilestoneEventFromToType,
  MilestoneEventListItemDto,
  MilestoneEventType,
  MilestoneSendMethodType,
} from './milestone-event.dto';

export const MilestoneEventListItemMapper = entity<MilestoneEventListItemDto>({
  eventDateValue: enumeration(MilestoneEventType),
  sendMethodValue: enumeration(MilestoneSendMethodType),
  sendFromValue: enumeration(MilestoneEventFromToType),
  sendToValue: enumeration(MilestoneEventFromToType),
});

export const MilestoneEventDetailsMapper = entity<MilestoneEventDetailsDto>({
  sendMethod: enumeration(MilestoneSendMethodType),
  sendWhen: enumeration(MilestoneEventFiresType),
  sendFrom: enumeration(MilestoneEventFromToType),
  sendFromSystemRole: UserSystemRoleIntMapper,
  sendTo: enumeration(MilestoneEventFromToType),
  sendToSystemRole: UserSystemRoleIntMapper,
});
